import { StyleSheet } from 'react-native';

import { centeredBox, extraSmallPaddingBottomBox } from '../../view-style';

export default StyleSheet.create({
  container: {
    ...centeredBox,
    ...extraSmallPaddingBottomBox,
  },
});
